import * as React from "react";
import { useId } from "react";
import styled, { css } from "styled-components";
import { DropdownButton, Menu, MenuItem } from "components/bootstrap";
import StringUtils from "util/StringUtils";
import useActiveQueryId from "views/hooks/useActiveQueryId";
import useViewsDispatch from "views/stores/useViewsDispatch";
import { addValuesToQuery, excludeValuesFromQuery } from "views/logic/valueactions/MultipleValuesQueryHandler";
const Container = styled.div(
  ({ theme }) => css`
    grid-row: 1;
    grid-column: 1;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: ${theme.spacings.sm};
    padding: ${theme.spacings.xs} 0;
  `
);
const FieldsSubmenu = ({ title, fieldValues, onSelect }) => /* @__PURE__ */ React.createElement(Menu.Sub, null, /* @__PURE__ */ React.createElement(Menu.Sub.Target, null, /* @__PURE__ */ React.createElement(Menu.Sub.Item, null, title)), /* @__PURE__ */ React.createElement(Menu.Sub.Dropdown, null, fieldValues.map((curFieldValues) => /* @__PURE__ */ React.createElement(MenuItem, { key: curFieldValues.field, onClick: () => onSelect(curFieldValues) }, curFieldValues.field))));
const SelectedRowsActions = ({ selectedRowsCount, fieldValues, onClearSelection }) => {
  const dropdownId = useId();
  const dispatch = useViewsDispatch();
  const queryId = useActiveQueryId();
  const onAddToQuery = ({ field, values, type }) => dispatch(addValuesToQuery({ queryId, field, values, type })).then(onClearSelection);
  const onExclude = ({ field, values, type }) => dispatch(excludeValuesFromQuery({ queryId, field, values, type })).then(onClearSelection);
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(DropdownButton, { bsSize: "xsmall", title: "Bulk actions", id: `selected-rows-actions-${dropdownId}` }, /* @__PURE__ */ React.createElement(FieldsSubmenu, { title: "Add to query", fieldValues, onSelect: onAddToQuery }), /* @__PURE__ */ React.createElement(FieldsSubmenu, { title: "Exclude from results", fieldValues, onSelect: onExclude }), /* @__PURE__ */ React.createElement(MenuItem, { divider: true }), /* @__PURE__ */ React.createElement(MenuItem, { onClick: onClearSelection }, "Cancel selection")), /* @__PURE__ */ React.createElement("span", null, selectedRowsCount, " ", StringUtils.pluralize(selectedRowsCount, "row", "rows"), " selected"));
};
export default SelectedRowsActions;
